import { User } from "@/data/interfaces/User";
import api from "./api";

export interface UpdateUserData {
  surname: string;
  phone: string;
}

const updateUser = async (userData: UpdateUserData) => {
  const resp = await api.put("/user", userData);
  return resp.data as User;
};

export default {
  updateUser,
};
